import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacyPolicy-page">
      {/* Hero Section */}
      <section className="privacyPolicy-hero">
        <div className="privacyPolicy-heroOverlay">
          <h1>Privacy Policy</h1>
          <p>Your privacy is important to us. Learn how we handle your data responsibly.</p>
        </div>
      </section>

      {/* Content */}
      <section className="privacyPolicy-content">
        <div className="privacyPolicy-card">
          <h2>1. Information We Collect</h2>
          <p>
            We may collect personal information such as your name, email, phone number, and 
            payment details when you use our services. We also collect non-personal 
            information like device type, browser, and IP address for analytics.
          </p>
        </div>

        <div className="privacyPolicy-card">
          <h2>2. How We Use Your Information</h2>
          <p>
            Your data helps us provide and improve our services, process bookings, communicate 
            with you, and ensure a personalized experience. We do not sell or rent your 
            personal data to third parties.
          </p>
        </div>

        <div className="privacyPolicy-card">
          <h2>3. Data Protection</h2>
          <p>
            We implement strict security measures to safeguard your data. However, no method 
            of electronic storage is 100% secure, and we cannot guarantee absolute security.
          </p>
        </div>

        <div className="privacyPolicy-card">
          <h2>4. Cookies</h2>
          <p>
            Our website uses cookies to enhance your browsing experience. You may choose to 
            disable cookies in your browser settings, but some features may not function properly.
          </p>
        </div>

        <div className="privacyPolicy-card">
          <h2>5. Third-Party Services</h2>
          <p>
            We may use trusted third-party tools (such as payment gateways and analytics 
            services) that collect limited information to perform their functions.
          </p>
        </div>

        <div className="privacyPolicy-card">
          <h2>6. Your Rights</h2>
          <p>
            You have the right to access, update, or request deletion of your personal 
            information. For any queries, please contact us at{" "}
            <a href="mailto:support@abasinexpress.com">support@abasinexpress.com</a>.
          </p>
        </div>

        <div className="privacyPolicy-card">
          <h2>7. Updates to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted 
            on this page with a revised date.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
